import { merge } from 'lodash'
import { create } from 'zustand'
import { subscribeWithSelector } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

export type State = {
  muted: boolean
  played: boolean
  progress: boolean
  detune: number
}

export type Actions = {
  // eslint-disable-next-line no-unused-vars
  setState: (state?: Partial<State>) => void
}

const initialState: State = {
  muted: true,
  played: false,
  progress: false,
  detune: 0
}

const useMixerStore = create(
  subscribeWithSelector(
    immer<State & Actions>((set) => ({
      ...initialState,
      setState: (state) => set((prevState) => merge(prevState, state))
    }))
  )
)

export { useMixerStore }
